var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "birthday-stat-v3",
    },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _c("div", { staticClass: "header-left" }, [
          _vm._m(0),
          _c("div", [
            _c("div", { staticClass: "title-with-pill" }, [
              _c("h2", { staticClass: "section-main-title" }, [
                _vm._v("Thống Kê Sinh Nhật"),
              ]),
              _c("span", { staticClass: "live-status-pill" }, [
                _c("span", { staticClass: "pulse-dot" }),
                _vm._v(
                  " Tháng " + _vm._s(_vm.formattedMonthLabel) + "\n          "
                ),
              ]),
            ]),
            _c("p", { staticClass: "section-subtitle" }, [
              _vm._v(
                "\n          Theo dõi danh sách sinh nhật học sinh, phụ huynh và đội ngũ nhân sự trong tháng để kịp thời gửi lời chúc mừng\n        "
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "header-filters" }, [
          _c(
            "div",
            { staticClass: "month-filter-wrapper" },
            [
              _c(
                "button",
                {
                  staticClass: "month-nav-btn",
                  attrs: { type: "button", title: "Tháng trước" },
                  on: {
                    click: function ($event) {
                      return _vm.changeMonth(-1)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-arrow-left" })]
              ),
              _c("el-date-picker", {
                staticClass: "birthday-month-picker",
                attrs: {
                  type: "month",
                  size: "small",
                  format: "MM/yyyy",
                  "value-format": "yyyy-MM",
                  placeholder: "Chọn tháng",
                  clearable: false,
                },
                on: { change: _vm.handleMonthChange },
                model: {
                  value: _vm.selectedMonth,
                  callback: function ($$v) {
                    _vm.selectedMonth = $$v
                  },
                  expression: "selectedMonth",
                },
              }),
              _c(
                "button",
                {
                  staticClass: "month-current-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.setCurrentMonth },
                },
                [_vm._v("\n          Tháng này\n        ")]
              ),
              _c(
                "button",
                {
                  staticClass: "month-nav-btn",
                  attrs: { type: "button", title: "Tháng sau" },
                  on: {
                    click: function ($event) {
                      return _vm.changeMonth(1)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-arrow-right" })]
              ),
            ],
            1
          ),
          _vm.overview
            ? _c("div", { staticClass: "total-badge-chip" }, [
                _c("i", { staticClass: "el-icon-bell" }),
                _c("span", [
                  _vm._v("Tổng: "),
                  _c("strong", [_vm._v(_vm._s(_vm.totalAllBirthdays))]),
                  _vm._v(" sinh nhật"),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.error
        ? _c(
            "div",
            [
              _c("el-alert", {
                attrs: {
                  title: _vm.error,
                  type: "error",
                  "show-icon": "",
                  closable: false,
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.loadMonth },
                },
                [_vm._v("Thử lại")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.overview
        ? _c("div", { staticClass: "birthday-kpi-grid" }, [
            _c(
              "div",
              {
                staticClass: "birthday-kpi-card kpi-student",
                attrs: { role: "button", tabindex: "0" },
                on: {
                  click: function ($event) {
                    return _vm.openDialog("student")
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.openDialog("student")
                  },
                },
              },
              [
                _vm._m(1),
                _c("div", { staticClass: "kpi-body" }, [
                  _c("span", { staticClass: "kpi-label" }, [
                    _vm._v("Sinh Nhật Học Sinh"),
                  ]),
                  _c("div", { staticClass: "kpi-number-row" }, [
                    _c("strong", { staticClass: "kpi-value text-rose-dark" }, [
                      _vm._v(_vm._s(_vm.overview.students.total)),
                    ]),
                    _c("span", { staticClass: "kpi-unit" }, [
                      _vm._v("học sinh"),
                    ]),
                  ]),
                  _c("p", { staticClass: "kpi-desc" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.studentBoyCount) +
                        " nam • " +
                        _vm._s(_vm.studentGirlCount) +
                        " nữ"
                    ),
                    _vm.overview.students.unknown
                      ? _c("span", [
                          _vm._v(
                            " • " +
                              _vm._s(_vm.overview.students.unknown) +
                              " chưa xác định"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(
                      " trong tháng " +
                        _vm._s(_vm.formattedMonthLabel) +
                        "\n        "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "kpi-footer-action text-rose" }, [
                  _c("span", [
                    _vm._v(
                      "Bấm xem danh sách chi tiết (" +
                        _vm._s(_vm.overview.students.total) +
                        ")"
                    ),
                  ]),
                  _c("i", { staticClass: "el-icon-right" }),
                ]),
                _c("div", { staticClass: "card-glow-bar glow-rose" }),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "birthday-kpi-card kpi-parent",
                attrs: { role: "button", tabindex: "0" },
                on: {
                  click: function ($event) {
                    return _vm.openDialog("parent")
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.openDialog("parent")
                  },
                },
              },
              [
                _vm._m(2),
                _c("div", { staticClass: "kpi-body" }, [
                  _c("span", { staticClass: "kpi-label" }, [
                    _vm._v("Sinh Nhật Phụ Huynh"),
                  ]),
                  _c("div", { staticClass: "kpi-number-row" }, [
                    _c(
                      "strong",
                      { staticClass: "kpi-value text-indigo-dark" },
                      [_vm._v(_vm._s(_vm.overview.parents.total))]
                    ),
                    _c("span", { staticClass: "kpi-unit" }, [
                      _vm._v("phụ huynh"),
                    ]),
                  ]),
                  _c("p", { staticClass: "kpi-desc" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.parentFatherCount) +
                        " bố • " +
                        _vm._s(_vm.parentMotherCount) +
                        " mẹ"
                    ),
                    _vm.overview.parents.unknown
                      ? _c("span", [
                          _vm._v(
                            " • " +
                              _vm._s(_vm.overview.parents.unknown) +
                              " chưa xác định"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(
                      " trong tháng " +
                        _vm._s(_vm.formattedMonthLabel) +
                        "\n        "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "kpi-footer-action text-indigo" }, [
                  _c("span", [
                    _vm._v(
                      "Bấm xem danh sách chi tiết (" +
                        _vm._s(_vm.overview.parents.total) +
                        ")"
                    ),
                  ]),
                  _c("i", { staticClass: "el-icon-right" }),
                ]),
                _c("div", { staticClass: "card-glow-bar glow-indigo" }),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "birthday-kpi-card kpi-employee",
                attrs: { role: "button", tabindex: "0" },
                on: {
                  click: function ($event) {
                    return _vm.openDialog("employee")
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.openDialog("employee")
                  },
                },
              },
              [
                _vm._m(3),
                _c("div", { staticClass: "kpi-body" }, [
                  _c("span", { staticClass: "kpi-label" }, [
                    _vm._v("Sinh Nhật Nhân Sự"),
                  ]),
                  _c("div", { staticClass: "kpi-number-row" }, [
                    _c("strong", { staticClass: "kpi-value text-teal-dark" }, [
                      _vm._v(_vm._s(_vm.overview.employees.total)),
                    ]),
                    _c("span", { staticClass: "kpi-unit" }, [
                      _vm._v("nhân sự"),
                    ]),
                  ]),
                  _c("p", { staticClass: "kpi-desc" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.employeeMaleCount) +
                        " nam • " +
                        _vm._s(_vm.employeeFemaleCount) +
                        " nữ"
                    ),
                    _vm.overview.employees.unknown
                      ? _c("span", [
                          _vm._v(
                            " • " +
                              _vm._s(_vm.overview.employees.unknown) +
                              " chưa xác định"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" giáo viên & cán bộ\n        "),
                  ]),
                ]),
                _c("div", { staticClass: "kpi-footer-action text-teal" }, [
                  _c("span", [
                    _vm._v(
                      "Bấm xem danh sách chi tiết (" +
                        _vm._s(_vm.overview.employees.total) +
                        ")"
                    ),
                  ]),
                  _c("i", { staticClass: "el-icon-right" }),
                ]),
                _c("div", { staticClass: "card-glow-bar glow-teal" }),
              ]
            ),
          ])
        : _vm._e(),
      _vm.overview
        ? _c(
            "el-row",
            { staticClass: "charts-row", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { xs: 24, lg: 16 } }, [
                _c("div", { staticClass: "chart-card" }, [
                  _c("div", { staticClass: "chart-card-header" }, [
                    _c("div", { staticClass: "chart-title-group" }, [
                      _c("i", { staticClass: "el-icon-date chart-icon" }),
                      _c("div", [
                        _c("h3", { staticClass: "chart-title" }, [
                          _vm._v(
                            "Phân Bố Ngày Sinh Nhật Trong Tháng " +
                              _vm._s(_vm.formattedMonthLabel)
                          ),
                        ]),
                        _c("span", { staticClass: "chart-subtitle" }, [
                          _vm._v(
                            "Biểu đồ tổng hợp ngày sinh nhật của học sinh, phụ huynh và nhân sự"
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "chart-legend-custom" }, [
                      _c("span", { staticClass: "legend-dot-item dot-rose" }, [
                        _vm._v(
                          "Học sinh (" +
                            _vm._s(_vm.overview.students.total) +
                            ")"
                        ),
                      ]),
                      _c(
                        "span",
                        { staticClass: "legend-dot-item dot-indigo" },
                        [
                          _vm._v(
                            "Phụ huynh (" +
                              _vm._s(_vm.overview.parents.total) +
                              ")"
                          ),
                        ]
                      ),
                      _c("span", { staticClass: "legend-dot-item dot-teal" }, [
                        _vm._v(
                          "Nhân sự (" +
                            _vm._s(_vm.overview.employees.total) +
                            ")"
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "chart-body" }, [
                    _c("div", {
                      ref: "chartBirthdayTimeline",
                      staticClass: "echart-box",
                    }),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { xs: 24, lg: 8 } }, [
                _c("div", { staticClass: "upcoming-card" }, [
                  _c("div", { staticClass: "upcoming-header" }, [
                    _c("div", { staticClass: "upcoming-title-wrap" }, [
                      _c("i", { staticClass: "el-icon-magic-stick text-rose" }),
                      _c("h3", { staticClass: "upcoming-title" }, [
                        _vm._v("Sinh Nhật Sắp Tới"),
                      ]),
                    ]),
                    _c("span", { staticClass: "upcoming-badge" }, [
                      _vm._v("Tháng " + _vm._s(_vm.formattedMonthLabel)),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "upcoming-list" },
                    _vm._l(_vm.upcomingBirthdays, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.type + "-" + item.id,
                          staticClass: "upcoming-item",
                          class: "type-" + item.type,
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upcoming-avatar",
                              class: "avatar-" + item.type,
                            },
                            [_c("i", { class: _vm.typeIcon(item.type) })]
                          ),
                          _c("div", { staticClass: "upcoming-info" }, [
                            _c("div", { staticClass: "upcoming-name-row" }, [
                              _c("span", { staticClass: "upcoming-name" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                              _c(
                                "span",
                                {
                                  class: [
                                    "upcoming-type-tag",
                                    "tag-" + item.type,
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.typeLabel(item.type)) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "upcoming-meta" }, [
                              _c("span", { staticClass: "meta-date" }, [
                                _c("i", { staticClass: "el-icon-time" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatBirthDate(item.birthDate)
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm.subInfo(item)
                                ? _c("span", { staticClass: "meta-sub" }, [
                                    _c("i", { staticClass: "el-icon-school" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.subInfo(item)) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c("div", { staticClass: "upcoming-countdown" }, [
                            _c(
                              "span",
                              {
                                staticClass: "countdown-badge",
                                class: "badge-" + item.type,
                              },
                              [
                                _vm._v(
                                  "\n                Ngày " +
                                    _vm._s(
                                      _vm.formatDayMonth(item.occurrenceDate)
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  !_vm.upcomingBirthdays.length
                    ? _c("div", { staticClass: "upcoming-list" }, [
                        _vm._v("Không có sinh nhật sắp tới trong tháng này."),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "upcoming-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "quick-view-all-btn",
                        on: { click: _vm.openAllDialog },
                      },
                      [
                        _c("i", { staticClass: "el-icon-search" }),
                        _vm._v(" Tra cứu toàn bộ danh sách\n          "),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.overview
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogVisible,
                title: _vm.dialogTitle,
                width: "78%",
                top: "5vh",
                "custom-class": "modern-birthday-dialog",
                "destroy-on-close": true,
                "close-on-click-modal": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "dialog-custom-header",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _c("div", { staticClass: "dialog-header-left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "dialog-icon-badge",
                        class: _vm.dialogBadgeClass,
                      },
                      [_c("i", { class: _vm.dialogIcon })]
                    ),
                    _c("div", [
                      _c("h3", { staticClass: "dialog-heading" }, [
                        _vm._v(_vm._s(_vm.dialogTitle)),
                      ]),
                      _c("p", { staticClass: "dialog-subheading" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(
                          " Tháng " +
                            _vm._s(_vm.formattedMonthLabel) +
                            "  • \n            "
                        ),
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" Tìm thấy "),
                        _c("strong", [_vm._v(_vm._s(_vm.filteredList.length))]),
                        _vm._v(" đối tượng  • \n          "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _c("div", { staticClass: "dialog-toolbar" }, [
                _c("div", { staticClass: "dialog-tabs" }, [
                  _c(
                    "button",
                    {
                      class: [
                        "d-tab-btn",
                        "tab-student",
                        { active: _vm.activeDialogType === "student" },
                      ],
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.switchDialogType("student")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-present" }),
                      _vm._v(
                        " Học Sinh (" +
                          _vm._s(_vm.overview.students.total) +
                          ")\n        "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      class: [
                        "d-tab-btn",
                        "tab-parent",
                        { active: _vm.activeDialogType === "parent" },
                      ],
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.switchDialogType("parent")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-user" }),
                      _vm._v(
                        " Phụ Huynh (" +
                          _vm._s(_vm.overview.parents.total) +
                          ")\n        "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      class: [
                        "d-tab-btn",
                        "tab-employee",
                        { active: _vm.activeDialogType === "employee" },
                      ],
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.switchDialogType("employee")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-s-cooperation" }),
                      _vm._v(
                        " Nhân Sự (" +
                          _vm._s(_vm.overview.employees.total) +
                          ")\n        "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "dialog-filters" },
                  [
                    _c("el-input", {
                      staticClass: "dialog-search-input",
                      attrs: {
                        size: "small",
                        placeholder: "Tìm theo họ tên...",
                        "prefix-icon": "el-icon-search",
                        clearable: "",
                      },
                      on: { input: _vm.handleDialogFilterChange },
                      model: {
                        value: _vm.dialogSearchText,
                        callback: function ($$v) {
                          _vm.dialogSearchText = $$v
                        },
                        expression: "dialogSearchText",
                      },
                    }),
                    _vm.activeDialogType !== "employee"
                      ? _c(
                          "el-select",
                          {
                            staticClass: "dialog-select",
                            attrs: {
                              size: "small",
                              placeholder: "Tất cả các khối",
                              clearable: "",
                            },
                            on: { change: _vm.handleDialogFilterChange },
                            model: {
                              value: _vm.dialogGradeFilter,
                              callback: function ($$v) {
                                _vm.dialogGradeFilter = $$v
                              },
                              expression: "dialogGradeFilter",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "Tất cả các khối", value: "" },
                            }),
                            _vm._l(_vm.gradeOptions, function (grade) {
                              return _c("el-option", {
                                key: grade,
                                attrs: { label: grade, value: grade },
                              })
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "el-select",
                      {
                        staticClass: "dialog-gender-select",
                        attrs: {
                          size: "small",
                          placeholder:
                            _vm.activeDialogType === "parent"
                              ? "Vai trò"
                              : "Giới tính",
                          clearable: "",
                        },
                        on: { change: _vm.handleDialogFilterChange },
                        model: {
                          value: _vm.dialogGenderFilter,
                          callback: function ($$v) {
                            _vm.dialogGenderFilter = $$v
                          },
                          expression: "dialogGenderFilter",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label:
                              _vm.activeDialogType === "parent"
                                ? "Tất cả vai trò"
                                : "Tất cả giới tính",
                            value: "",
                          },
                        }),
                        _vm.activeDialogType === "parent"
                          ? _c("el-option", {
                              attrs: { label: "Bố", value: "Bố" },
                            })
                          : _vm._e(),
                        _vm.activeDialogType === "parent"
                          ? _c("el-option", {
                              attrs: { label: "Mẹ", value: "Mẹ" },
                            })
                          : _vm._e(),
                        _vm.activeDialogType !== "parent"
                          ? _c("el-option", {
                              attrs: { label: "Nam", value: "Nam" },
                            })
                          : _vm._e(),
                        _vm.activeDialogType !== "parent"
                          ? _c("el-option", {
                              attrs: { label: "Nữ", value: "Nữ" },
                            })
                          : _vm._e(),
                        _c("el-option", {
                          attrs: {
                            label: "Chưa xác định",
                            value: "Chưa xác định",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "dialog-table-container" },
                [
                  _vm.activeDialogType === "student"
                    ? _c(
                        "el-table",
                        {
                          staticClass: "custom-birthday-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.paginatedList,
                            "empty-text": "Không có sinh nhật phù hợp",
                            stripe: "",
                            border: "",
                            "max-height": "450",
                            "header-cell-style": {
                              background: "#f8fafc",
                              color: "#334155",
                              fontWeight: "600",
                            },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "STT",
                              type: "index",
                              index: _vm.calcIndex,
                              align: "center",
                              width: "70",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "Họ tên",
                              "min-width": "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "name-cell" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "name-avatar",
                                            class:
                                              row.gender === "Nam"
                                                ? "avatar-boy"
                                                : "avatar-girl",
                                          },
                                          [
                                            _c("i", {
                                              class:
                                                row.gender === "Nam"
                                                  ? "el-icon-user"
                                                  : "el-icon-user-solid",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "name-text" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "full-name" },
                                              [_vm._v(_vm._s(row.name))]
                                            ),
                                            _vm.isTodayBirthday(
                                              row.occurrenceDate
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "today-birthday-badge",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  🎂 Hôm nay\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1297399962
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "gradeName",
                              label: "Khối",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "grade-cell-tag" },
                                        [_vm._v(_vm._s(row.gradeName))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3997616753
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "className",
                              label: "Lớp",
                              width: "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "class-pill",
                                          attrs: {
                                            size: "small",
                                            type: "info",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.className) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2675269147
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "gender",
                              label: "Giới tính",
                              align: "center",
                              width: "110",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "gender-tag",
                                          attrs: {
                                            size: "mini",
                                            type: _vm.genderTagType(row.gender),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.gender) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2210585002
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "birthDate",
                              label: "Ngày sinh",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "birthdate-tag" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-date",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatBirthDate(
                                                  row.birthDate
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1063538964
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm.activeDialogType === "parent"
                    ? _c(
                        "el-table",
                        {
                          staticClass: "custom-birthday-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.paginatedList,
                            "empty-text": "Không có sinh nhật phù hợp",
                            stripe: "",
                            border: "",
                            "max-height": "450",
                            "header-cell-style": {
                              background: "#f8fafc",
                              color: "#334155",
                              fontWeight: "600",
                            },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "STT",
                              type: "index",
                              index: _vm.calcIndex,
                              align: "center",
                              width: "70",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "Họ tên",
                              "min-width": "170",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "name-cell" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "name-avatar avatar-parent",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-user",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "name-text" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "full-name" },
                                              [_vm._v(_vm._s(row.name))]
                                            ),
                                            row.childCount > 1
                                              ? _c("span", [
                                                  _vm._v(
                                                    " và " +
                                                      _vm._s(
                                                        row.childCount - 1
                                                      ) +
                                                      " con khác"
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.isTodayBirthday(
                                              row.occurrenceDate
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "today-birthday-badge",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  🎂 Hôm nay\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1303739222
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "studentName",
                              label: "Tên học sinh",
                              "min-width": "170",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "student-link" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-link",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(row.studentName) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2680016070
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "gradeName",
                              label: "Khối",
                              width: "130",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "grade-cell-tag" },
                                        [_vm._v(_vm._s(row.gradeName))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3997616753
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "className",
                              label: "Lớp",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "class-pill",
                                          attrs: {
                                            size: "small",
                                            type: "info",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.className) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2675269147
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "relation",
                              label: "Vai trò",
                              align: "center",
                              width: "110",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "gender-tag",
                                          attrs: {
                                            size: "mini",
                                            type:
                                              row.relation === "Bố"
                                                ? "primary"
                                                : row.relation === "Mẹ"
                                                ? "danger"
                                                : "info",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.relation) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1808716706
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "birthDate",
                              label: "Ngày sinh",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "birthdate-tag" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-date",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatBirthDate(
                                                  row.birthDate
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1063538964
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm.activeDialogType === "employee"
                    ? _c(
                        "el-table",
                        {
                          staticClass: "custom-birthday-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.paginatedList,
                            "empty-text": "Không có sinh nhật phù hợp",
                            stripe: "",
                            border: "",
                            "max-height": "450",
                            "header-cell-style": {
                              background: "#f8fafc",
                              color: "#334155",
                              fontWeight: "600",
                            },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "STT",
                              type: "index",
                              index: _vm.calcIndex,
                              align: "center",
                              width: "70",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "Họ tên",
                              "min-width": "220",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("div", { staticClass: "name-cell" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "name-avatar avatar-employee",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-s-custom",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "name-text" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "full-name" },
                                              [_vm._v(_vm._s(row.name))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "emp-role-tag" },
                                              [_vm._v(_vm._s(row.roleTitle))]
                                            ),
                                            _vm.isTodayBirthday(
                                              row.occurrenceDate
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "today-birthday-badge",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  🎂 Hôm nay\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              852776421
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "gender",
                              label: "Giới tính",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          staticClass: "gender-tag",
                                          attrs: {
                                            size: "mini",
                                            type: _vm.genderTagType(row.gender),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.gender) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2210585002
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "birthDate",
                              label: "Ngày sinh",
                              align: "center",
                              width: "160",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "birthdate-tag" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-date",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatBirthDate(
                                                  row.birthDate
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1063538964
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "dialog-pagination-bar" },
                [
                  _c("span", { staticClass: "pagination-info" }, [
                    _vm._v("\n        Hiển thị "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.filteredList.length
                            ? (_vm.currentPage - 1) * _vm.pageSize + 1
                            : 0
                        )
                      ),
                    ]),
                    _vm._v(" -\n        "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          Math.min(
                            _vm.currentPage * _vm.pageSize,
                            _vm.filteredList.length
                          )
                        )
                      ),
                    ]),
                    _vm._v("\n        trên tổng số "),
                    _c("strong", [_vm._v(_vm._s(_vm.filteredList.length))]),
                    _vm._v(" người\n      "),
                  ]),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-size": _vm.pageSize,
                      total: _vm.filteredList.length,
                      layout: "prev, pager, next",
                      background: "",
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        _vm.currentPage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.currentPage = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("Đóng")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-icon-badge" }, [
      _c("i", { staticClass: "el-icon-present" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-top" }, [
      _c("div", { staticClass: "kpi-icon-wrap bg-rose-subtle text-rose" }, [
        _c("i", { staticClass: "el-icon-present" }),
      ]),
      _c("span", { staticClass: "kpi-tag tag-rose" }, [_vm._v("Học sinh")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-top" }, [
      _c("div", { staticClass: "kpi-icon-wrap bg-indigo-subtle text-indigo" }, [
        _c("i", { staticClass: "el-icon-user" }),
      ]),
      _c("span", { staticClass: "kpi-tag tag-indigo" }, [_vm._v("Phụ huynh")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-top" }, [
      _c("div", { staticClass: "kpi-icon-wrap bg-teal-subtle text-teal" }, [
        _c("i", { staticClass: "el-icon-s-cooperation" }),
      ]),
      _c("span", { staticClass: "kpi-tag tag-teal" }, [_vm._v("Nhân sự")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }